<template>
  <ul>
    <li
      v-for="(toast, index) in toasts"
      :key="index"
      :class="toast.type">
      {{ toast.message }}
    </li>
  </ul>
</template>

<script>
export default {
  computed: {
    toasts () {
      return this.$store.state.toast.data
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    width: 100%;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    top: 100px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 999;
    li {
      display: block;
      margin: 10px auto;
      padding: 15px;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
      font-size: 14px;
      color: #333;
      text-align: center;
      transition: all 0.3s ease;
      font-family: AvenirNextLTPro-MediumCn;
      &.error {
        background-color: #f56c6c;
        color: #fff;
      }
      &.success {
        background-color: #67c23a;
        color: #fff;
      }
    }
  }
</style>
